<template>
  <div class="training-page-layout">
    <div class="training-page-layout__main"
         :style="mainStyle">
      <router-view />
    </div>
    <training-ai-assistant-sidebar v-if="aiAssistantEnabled"
                                   :context="aiContext"
                                   :page-title="pageTitle"
                                   @expand-change="onSidebarExpandChange" />
  </div>
</template>

<script>
import TrainingAiAssistantSidebar from '@views/training/components/TrainingAiAssistantSidebar.vue'
import { TRAINING_AI_ASSISTANT_ENABLED } from '@views/training/training.constants'

const SIDEBAR_WIDTH_COLLAPSED = 48
const SIDEBAR_WIDTH_EXPANDED = 400
const SIDEBAR_GAP = 8

export default {
  name: 'TrainingPageLayout',
  components: {
    TrainingAiAssistantSidebar,
  },
  data () {
    return {
      aiSidebarExpanded: false,
    }
  },
  computed: {
    aiAssistantEnabled () {
      return TRAINING_AI_ASSISTANT_ENABLED
    },
    aiContext () {
      return this.$route.meta.aiContext || 'instruction-list'
    },
    pageTitle () {
      return this.$route.meta.title || ''
    },
    mainStyle () {
      if (!this.aiAssistantEnabled) {
        return {}
      }
      const sidebarWidth = this.aiSidebarExpanded
        ? SIDEBAR_WIDTH_EXPANDED
        : SIDEBAR_WIDTH_COLLAPSED
      return {
        paddingRight: `${sidebarWidth + SIDEBAR_GAP}px`,
      }
    },
  },
  methods: {
    onSidebarExpandChange (expanded) {
      this.aiSidebarExpanded = !!expanded
    },
  },
}
</script>

<style lang="scss" scoped>
.training-page-layout {
  min-height: 100%;

  &__main {
    min-width: 0;
    transition: padding-right 0.2s ease;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/layouts/TrainingPageLayout.vue